var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 1.143h11m0 11H.5",
    stroke: "#131A4F",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "77bcde98aaae131d608f5faa9b5e57a4.svg";
export { SvgOpen as ReactComponent };